// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-type_tip[data-v-35d33a6e]{font-size:12px;color:#909399;line-height:1em}.btn-sf-del[data-v-35d33a6e]{cursor:pointer}.btn-sf-del[data-v-35d33a6e]:hover{color:red}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
